export const APP_VERSION = "690608-02 PRD";
export const DEFAULT_RELEASE_NOTES = "";
